var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBarNegative = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 0V32",
  className: "chart-axis-line-stroke",
  strokeWidth: 1.5
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 32,
  width: 4,
  height: 7,
  transform: "rotate(-90 7 32)",
  className: "chart-qualitative-02"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 25,
  width: 4,
  height: 7,
  transform: "rotate(90 25 0)",
  className: "chart-qualitative-01"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 26,
  width: 4,
  height: 11,
  transform: "rotate(-90 3 26)",
  className: "chart-qualitative-02"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 6,
  width: 4,
  height: 11,
  transform: "rotate(90 29 6)",
  className: "chart-qualitative-01"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  y: 20,
  width: 4,
  height: 14,
  transform: "rotate(-90 0 20)",
  className: "chart-qualitative-02"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 32,
  y: 12,
  width: 4,
  height: 14,
  transform: "rotate(90 32 12)",
  className: "chart-qualitative-01"
})));
export { SvgBarNegative as ReactComponent };
export default __webpack_public_path__ + "bar_negative.e231f30de566b061f0bf5ccbeea24017.svg";